import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../shared/services/local-storage/local-storage.service';

export const opsAdminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);

  if (localStorageService.getIsShohayOpsAdmin()) {
    return true;
  } else {
    return false;
  }
};
